// Number formatting helpers used by the dashboard + summary cards.
export function formatNum(num, suffix = '') {
  if (num == null) return '—';
  const abs = Math.abs(num);
  if (abs >= 1_000_000) return (num / 1_000_000).toFixed(1) + 'M' + suffix;
  if (abs >= 1_000)     return (num / 1_000).toFixed(1) + 'K' + suffix;
  return num.toLocaleString() + suffix;
}
